<template>
    <v-container>
        <h2> Estamos trabajando en ello</h2>
    </v-container>
</template>
<script>
export default {
    data:() => ({

    })
}
</script>